import * as Edit from './ImageDataEdit.js';

export default class PenDrawableImage extends ImageData {
  constructor(width, height, orgImage, pixelColor) {
    super(width, height);
    this.data.set(orgImage.data);
    this._orgImage = orgImage;
    this._pixelColor = pixelColor;
    this._map = new Uint8Array(width * height);
    this._prevPixel = null;
    this._prev2Pixel = null;
  }
  _idx(x, y) {
    return y * this.width + x;
  }
  _dotThick(centerX, centerY, thick) {
    const [startX, startY, endX, endY] = Edit.getThickRect(centerX, centerY, thick, this.width, this.height);
    for(let y = startY; y < endY; ++y) {
      for(let x = startX; x < endX; ++x) {
        this._map[this._idx(x, y)] = 1;
      }
    }
  }
  _dotPixelPerfect(x, y) {
    if(0 <= x && x < this.width && 0 <= y && y < this.height) {
      const idx = this._idx(x, y);
      if(!this._prevPixel) {
        if(!this._map[idx]) {
          this._map[idx] = 1;
          this._prevPixel = {x, y};
        }
      } else if(x !== this._prevPixel.x || y !== this._prevPixel.y) {
        if(this._map[idx]) {
          this._prev2Pixel = null;
          this._prevPixel = null;
        } else if(this._prev2Pixel && Math.abs(this._prev2Pixel.x - x) === 1 && Math.abs(this._prev2Pixel.y - y) === 1) {
          this._map[this._idx(this._prevPixel.x, this._prevPixel.y)] = 0;
          this._prev2Pixel = null;
          this._prevPixel = {x, y};
          this._map[idx] = 1;
        } else {
          this._prev2Pixel = this._prevPixel;
          this._prevPixel = {x, y};
          this._map[idx] = 1;
        }
      }
    }
  }
  line(x1, y1, x2, y2, thick, pixelPerfect) {
    if(pixelPerfect) {
      Edit.drawLineBase(x1, y1, x2, y2, (x, y) => this._dotPixelPerfect(x, y));
    } else {
      Edit.drawLineBase(x1, y1, x2, y2, (x, y) => this._dotThick(x, y, thick));
    }
    this._updateImage();
  }
  _updateImage() {
    this.data.set(this._orgImage.data);
    for(let i = 0; i < this._map.length; ++i) {
      if(this._map[i]) {
        this.data.set(this._pixelColor, i * 4);
      }
    }
  }
}
